import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import EgPlatform from './egPlatform/egPlatform';
import SentinelOne from './sentinelOne/sentinelOne';
import BaroPAM from './baroPam/baroPAM';

const ProductPage = () => {
  const { pathname } = useLocation();
  const [selectTab, setSelectTab] = useState('eg');

  useEffect(() => {
    if (pathname === '/product/EG-Platform') {
      setSelectTab('eg');
    }
    if (pathname === '/product/SentinelONE') {
      setSelectTab('one');
    }
    if (pathname === '/product/BaroPAM') {
      setSelectTab('baro');
    }
  }, [pathname]);

  return (
    <>
      <section className="common product">
        <div className="container">
          <div className="mainTit">
            <h2>Product</h2>
            <p>{selectTab === 'eg' && 'Home > Product > EG-Platform'}</p>
            <p>{selectTab === 'one' && 'Home > Product > SentinelONE'}</p>
            <p>{selectTab === 'baro' && 'Home > Product > BaroPAM'}</p>
          </div>
        </div>
      </section>
      <div className="tabMenu">
        <ul className="w1200 flex">
          <li>
            <NavLink to="/product/EG-Platform">EG-Platform</NavLink>
          </li>
          <li>
            <NavLink to="/product/SentinelONE">SentinelOne</NavLink>
          </li>
          <li>
            <NavLink to="/product/BaroPAM">BaroPAM</NavLink>
          </li>
        </ul>
      </div>
      {selectTab === 'eg' && <EgPlatform />}
      {selectTab === 'one' && <SentinelOne />}
      {selectTab === 'baro' && <BaroPAM />}
    </>
  );
};

export default ProductPage;
